import type { SVGProps } from 'react';
const SvgClearAll = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#clear_all_svg__a)">
      <path
        fill="currentColor"
        d="M5 13h14v-2H5v2Zm-2 4h14v-2H3v2ZM7 7v2h14V7H7Z"
      />
    </g>
    <defs>
      <clipPath id="clear_all_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgClearAll;
